var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSportCyclingBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C16.1046 4 17 3.10457 17 2C17 0.89543 16.1046 0 15 0C13.8954 0 13 0.89543 13 2C13 3.10457 13.8954 4 15 4Z",
    fill: "#24272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.55229 15.5523 9 15 9L13.5352 9C13.2008 9 12.8886 8.8329 12.7031 8.5547L11 6L8.99998 8L10.7808 10.2261C10.9227 10.4034 11 10.6237 11 10.8508V15C11 15.5523 10.5523 16 9.99998 16C9.44769 16 8.99998 15.5523 8.99998 15V12L5 8C5 8 4.5 7.5 4.5 7C4.5 6.5 4.64998 6.33654 4.99998 6L8.84998 2.66347C9.19998 2.32693 9.66665 2.10257 10.25 2.10257C11.0666 2.10257 11.65 2.43911 12 3.00001L14 7L15 7C15.5523 7 16 7.44772 16 8Z",
    fill: "#24272A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C8 16.2091 6.20914 18 4 18C1.79086 18 0 16.2091 0 14C0 11.7909 1.79086 10 4 10C6.20914 10 8 11.7909 8 14ZM6 14C6 15.1046 5.10457 16 4 16C2.89543 16 2 15.1046 2 14C2 12.8954 2.89543 12 4 12C5.10457 12 6 12.8954 6 14Z",
    fill: "#24272A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C13.7909 10 12 11.7909 12 14C12 16.2091 13.7909 18 16 18ZM16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12C14.8954 12 14 12.8954 14 14C14 15.1046 14.8954 16 16 16Z",
    fill: "#24272A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSportCyclingBlack);
export default __webpack_public_path__ + "static/media/Icon-Sport-Cycling-Black.4412fdc2d34a51f1b4e6d20984f311af.svg";
export { ForwardRef as ReactComponent };